<script setup lang="ts">
import { UiPage } from '#components'

const { event } = useRoute().params

const { data: eventData } = await useApi('/public_events/{event}', {
  path: { event: Number(event) },
  key: `event-${event}`,
})

const googleSrc = computed(() => {
  return `https://www.google.com/maps/embed/v1/place?key=AIzaSyBNYVW95M9oWQemV3RVZ8KuQDEpNVa1NME&q=${eventData.value?.address_simple}`
})

const { t } = useI18n()

defineOgImageComponent('DartsSpace', {
  siteLogo: '/light-logo.png',
  headline: t('View all tournaments'),
  title: eventData.value?.name ?? 'Event',
  description: eventData.value?.description?.slice(0, 100) ?? 'Event',
  image: eventData.value?.image?.replace('dartsspace.test', 'api.dartsspace.com') ?? '/light-logo.png',
})
const localePath = useLocalePath()
</script>

<template>
  <UiPage
    v-if="eventData"
    padding
    class="flex flex-col gap-4"
  >
    <UiCard
      :title="eventData.name"
      :description="eventData.description ?? undefined"
    >
      <template #actions>
        <CommonShareButtons :url="'https://dartsspace.com' + localePath(`/events/${eventData.id}`)" />
      </template>
      <template
        v-if="eventData.start_date && eventData.end_date && eventData.type === 'one_time_event'"
        #content
      >
        <UiCardContent>
          <CommonDateTime
            :date="eventData.start_date"
          />
          -
          <CommonDateTime
            v-if="eventData.end_date"
            :date="eventData.end_date"
          />
        </UiCardContent>
      </template>
    </UiCard>
    <div class="grid md:grid-cols-2 gap-4">
      <UiCard :title="$t('Tournaments')">
        <template #content>
          <UiCardContent>
            <template
              v-for="tournament in eventData.tournaments"
              :key="tournament.id"
            >
              <TournamentCard :tournament="tournament" />
            </template>
          </UiCardContent>
        </template>
      </UiCard>
      <UiCard :title="$t('Information')">
        <template #content>
          <UiCardContent>
            <div class="grid grid-cols-1 gap-4">
              <div>
                <ClientOnly>
                  <QRCode :data="'https://dartsspace.com' + localePath(`/events/${eventData.id}`)" />
                  {{ $t('Use right click to save as image') }}
                </ClientOnly>
              </div>
              <div>
                <address
                  v-if="eventData.address"
                  class="text-subtitle2 mb-4"
                >
                  <ul>
                    <li>{{ eventData.address.street }}</li>
                    <li>{{ eventData.address.postalCode }} {{ eventData.address.city }}</li>
                    <li>
                      {{ eventData.address.province }}
                    </li>
                    <li>{{ eventData.address.countryCode }}</li>
                  </ul>
                </address>

                <iframe
                  height="250"
                  style="border:0"
                  loading="lazy"
                  class="rounded-lg overflow-hidden w-full"
                  referrerpolicy="no-referrer-when-downgrade"
                  :src="googleSrc"
                />
              </div>
            </div>
          </UiCardContent>
        </template>
      </UiCard>
    </div>
  </UiPage>
</template>
